import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { DropDownService } from '../../Services/DropDown/dropdownService';
import { RegionModel, RMHModel } from '../../models/DropDwon/RegionModel';
import { ZoneModel } from '../../models/DropDwon/ZoneModel';
import { DivisionModel } from '../../models/DropDwon/DvisionModel';
import { SBUModel } from '../../models/DropDwon/SBUModel';
import { DropDownRequest, DropDownResponse } from '../../models/DropDwon/DropDownRequest';
import { productModel } from '../../models/DropDwon/ProductModel';
import { CropModel } from '../../models/DropDwon/CropModel';
import { AdditionalRequirment } from '../../Models/AdditionalRequirment/AdditionalRequirment'
import { Observable } from 'rxjs/Rx';
import { FormsModule } from '@angular/forms';
import { global } from '../../models/global';
import { ToastrService } from 'ngx-toastr';
import { AdditionalRequirementService } from '../../Services/AdditionalRequirement/add-requirement.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { YearModel } from 'src/app/Models/DropDwon/YearModel';
import { start } from 'repl';

@Component({
    selector: 'additional-requirment',
    templateUrl: './addtionalRequirment.component.html'
})
export class AdditionalRequirmentComponent implements OnInit {

    @ViewChild('regionSelect') regionSelect;
    @ViewChild('productSelect') productSelect;
    @ViewChild('cropSelect') cropSelect;
    @ViewChild('yearSelect') yearSelect;
    @ViewChild('month') month;
    @ViewChild('sbu') sbu;
    @ViewChild('division') division;
    @ViewChild('zone') zone;
    @ViewChild('file') file;
    @ViewChild('rmh') rmh;
    @ViewChild('year') year;
    @ViewChild('status')status

    public form: FormGroup;

    public monthList: any;
    public selectedMonth: any = [];
    public currentYear: any;
    public currentYearPlus: any;
    public Month: any;
    public dropdownMonthSettings: {};

    public RMHSettings = {};
    public RMHSelectedItems: RMHModel[];

    public RegionSettings = {};
    public RegionselectedItems: RegionModel[];

    public ProductSettings = {};
    public ProductSelectedItem: productModel[];

    public CropSettings = {};
    public CropSelectedItem: CropModel[];

    public SBUSettings = {};
    public SBUSelectedItem: SBUModel[];

    public DivisionSettings = {};
    public DivisionSelectedItem: DivisionModel[];

    public ZoneSettings = {};
    public ZoneSelectedItem: ZoneModel[];

    public YearSettings= {};
    public SSettings= {};
    public dropdownStatus: {status:string}
    public YearSelectedItem: YearModel[];

    public userId: string;
    public roleId: string;
    public isViewOnly: string;
    public FlagDropDown: string;
    public loader: string = "none";
    public files: File[] = [];
    public fileName: string = '';
    public document: AdditionalRequirment = new AdditionalRequirment();
    public ddlRequest: DropDownRequest = new DropDownRequest();
    public ddlResponse: DropDownResponse = new DropDownResponse();

    additionalReqObj: any = [];
    defaultView: boolean = true;
    totalRecord: any;
    currentPage: any;
    lastPage: any;
    isDisabledPrevious = true;
    isDisabledNext = false;
    userName: string;
    displayReject = 'none';
    recordsOnCurrentPage: number;
    startRecord: number = 1;
    endRecord: number;
    endRecordForHistory: number;
    IsSubmittButtonDisable: boolean = true;


    selectedReqType: string;
    selectedRegion: any[] = [];
    selectedSbu: any[] = [];
    selectedDivision: any[] = [];
    selectedZone: any[] = [];
    selectedRMH: any[] = [];
    commaSeperatedSbus: string;
    commaSeperatedDivisions: string;
    commaSeperatedZones: string;
    commaSeperatedRegions: string;
    commaSeperatedSDs: string;
    commaSeperatedRMH: string;
    approvalDetails: any = [];
// deepanshu code start
    currentPageForHistory: any;
    lastPageForHistory:any;
    totalRecordForHistory:any;
recordsOnCurrentPageForHistory: number = 0;
    startRecordForHistory:number=1;

isDisabledPreviousForHistory=true;
    isDisabledNextForHistory=true;
    // deepanshu code end


    defaultValue = 'none';

    constructor(private ddlServices: DropDownService, private toastr: ToastrService, private addReqServices: AdditionalRequirementService) {
        this.userName = localStorage.getItem('dsu_userName');
        this.userId = localStorage.getItem('dsu_userId');
        this.roleId = localStorage.getItem('dsu_roleId');
        this.isViewOnly = localStorage.getItem('dsu_isViewOnly');
        this.FlagDropDown = (this.roleId == "39" || this.roleId == "43" || this.roleId == "44") ? "Supervisor" : "DEFAULT";
    }

    ngOnInit() {

        this.currentYear = new Date();
        this.currentYearPlus = this.currentYear.getFullYear();
        this.Month = this.currentYear.getMonth();

        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = this.FlagDropDown;
        debugger;
        this.ddlServices.getAllHierarchyDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    debugger;
                    this.ddlResponse = response.data;
                    debugger;
                    this.ddlResponse.year=response.data.year;
                    this.ddlResponse.status=response.data.status;
                    this.SSetting();
                    //response.data.status
                    class YearItemList{
                        id: any;
                        text: any;
                    }
                      let requiredItem: YearItemList[] = [];
                      var obj = {
                        id : (new Date()).getFullYear(),
                        text: (new Date()).getFullYear()
                      }
                      requiredItem.push(obj)
                      this.year.selectedItems = requiredItem
                    //   for(var i=0;i<this.year.selectedItems.length; i++){
                    //       this.yearSelect.push(this.year.selectedItems[i].text)
                    //   }
                      this.SSetting();
                    this.YearSetting();
                    
                }
                else {
                    this.toastr.error(response.message);
                }

            }, error => {
            });
        this.getMonthList();
        this.SBUMHSetting();
        this.DivisionSetting();
        this.ZoneSetting();
        this.RegionSetting();
        this.RMHSetting();
        this.CropSetting();
        this.ProductSetting();
     
        this.YearSetting();
       
    }

    RegionSetting() {
        this.RegionSettings = {
            singleSelection: false,
            idField: 'regionCode',
            textField: 'regionName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            //maxHeight: 197,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Region Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    RMHSetting() {
        this.RMHSettings = {
            singleSelection: false,
            idField: 'rmhCode',
            textField: 'rmhName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            //maxHeight: 197,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No RMH Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    CropSetting() {
        this.CropSettings = {
            singleSelection: false,
            idField: 'cropId',
            textField: 'cropName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Crop Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    ProductSetting() {
        this.ProductSettings = {
            singleSelection: false,
            idField: 'productId',
            textField: 'productName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Product Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    YearSetting(){
        this.YearSettings = {
          singleSelection: true,
          idField: 'year',
          textField: 'year',
          enableCheckAll: false,
          selectAllText: 'Select All',
          unSelectAllText: 'UnSelect All',
          allowSearchFilter: false,
          limitSelection: -1,
          clearSearchFilter: false,
          itemsShowLimit: 1,
          searchPlaceholderText: 'Search',
          noDataAvailablePlaceholderText: 'No Year Found',
          closeDropDownOnSelection: false,
          showSelectedItemsAtTop: false,
          defaultOpen: false
        };
    }
    SSetting() {
        this.SSettings = {
            singleSelection:true,
            idField: 'status',
            textField: 'status',
          enableCheckAll: false,
          selectAllText: 'Select All',
          unSelectAllText: 'UnSelect All',
          allowSearchFilter: false,
          limitSelection: -1,
          clearSearchFilter: false,
          itemsShowLimit: 1,
          searchPlaceholderText: 'Search',
          noDataAvailablePlaceholderText: 'No Annual Found',
          closeDropDownOnSelection: false,
          showSelectedItemsAtTop: false,
          defaultOpen: false
        };
    }
    
    SBUMHSetting() {
        this.SBUSettings = {
            singleSelection: false,
            idField: 'sbuCode',
            textField: 'sbuName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No SBU Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    DivisionSetting() {
        this.DivisionSettings = {
            singleSelection: false,
            idField: 'divisionCode',
            textField: 'divisionName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Division Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    ZoneSetting() {
        this.ZoneSettings = {
            singleSelection: false,
            idField: 'zoneCode',
            textField: 'zoneName',
            enableCheckAll: true,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            allowSearchFilter: true,
            limitSelection: -1,
            clearSearchFilter: true,
            itemsShowLimit: 1,
            searchPlaceholderText: 'Search',
            noDataAvailablePlaceholderText: 'No Zone Found',
            closeDropDownOnSelection: false,
            showSelectedItemsAtTop: false,
            defaultOpen: false
        };
    }
    bindMonthDropdownSetting() {
        this.dropdownMonthSettings = {
            singleSelection: false,
            text: "Select Month",
            idField: 'Id',
            textField: 'Text',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 1,
            allowSearchFilter: true,
            noDataAvailablePlaceholderText: 'No Month Found'
        };
    }
    ConvertToCurrency(value:any)
    {
        
        var parts = value.toString().replace(',','').split(".");
        if(parts[0].length > 3){
        parts[0] = parts[0].slice(0,parts[0].length-3).replace(/\B(?=(\d{2})+(?!\d))/g, ",") +','+ parts[0].slice(parts[0].length-3,parts[0].length);
        }
        return parts.join(".");
    }
    getMonthList(): void {
        type MyArrayType = Array<{ Id: number, Text: string }>;
        const arrList: MyArrayType = [];
        this.bindMonthDropdownSetting();
        const arr: MyArrayType = [
            { Id: 1, Text: 'Jan' },
            { Id: 2, Text: 'Feb' },
            { Id: 3, Text: 'Mar' },
            { Id: 4, Text: 'Apr' },
            { Id: 5, Text: 'May' },
            { Id: 6, Text: 'Jun' },
            { Id: 7, Text: 'Jul' },
            { Id: 8, Text: 'Aug' },
            { Id: 9, Text: 'Sep' },
            { Id: 10, Text: 'Oct' },
            { Id: 11, Text: 'Nov' },
            { Id: 12, Text: 'Dec' },
        ];
        for (var i = 0; i <= this.Month; i++) {
            arrList.push(arr[i]);
        }
        this.monthList = arrList;
        this.selectedMonth = this.monthList.filter((item) => item.Id === (this.Month + 1));

    }

    public onSBUSelect(item: any) {
        this.selectedSbu = [];
        for (var i = 0; i < this.sbu.selectedItems.length; i++) {
            this.selectedSbu.push(this.sbu.selectedItems[i].id)
        }
        this.commaSeperatedSbus = this.selectedSbu.join(", ");
        this.GetSBUWiseData(this.sbu.selectedItems);
    }
    public onSBUDeSelect(item: any) {
        this.selectedSbu = [];
        for (var i = 0; i < this.sbu.selectedItems.length; i++) {
            this.selectedSbu.push(this.sbu.selectedItems[i].id)
        }
        this.commaSeperatedSbus = this.selectedSbu.join(", ");

        this.GetSBUWiseData(this.sbu.selectedItems);
    }

    public onSBUSelectAll(items: any) {
        this.selectedSbu = [];
        for (var i = 0; i < this.sbu.selectedItems.length; i++) {
            this.selectedSbu.push(this.sbu.selectedItems[i].id)
        }
        this.commaSeperatedSbus = this.selectedSbu.join(", ")
        this.GetSBUWiseData(this.sbu.selectedItems);
    }
    public onSBUDeSelectAll(items: any) {
        this.selectedSbu = [];
        this.commaSeperatedSbus = '';
        this.GetSBUWiseData(this.sbu.selectedItems);
    }

    public onDivisionSelect(item: any) {
        this.selectedDivision = []
        for (var i = 0; i < this.division.selectedItems.length; i++) {
            this.selectedDivision.push(this.division.selectedItems[i].id)
        }
        this.commaSeperatedDivisions = this.selectedDivision.join(", ");

        this.GetDivisionWiseData(this.division.selectedItems);

    }
    public onDivisionDeSelect(item: any) {
        this.selectedDivision = []
        for (var i = 0; i < this.division.selectedItems.length; i++) {
            this.selectedDivision.push(this.division.selectedItems[i].id)
        }
        this.commaSeperatedDivisions = this.selectedDivision.join(", ")
        this.GetDivisionWiseData(this.division.selectedItems);
    }

    public onDivisionSelectAll(items: any) {
        this.selectedDivision = []
        for (var i = 0; i < this.division.selectedItems.length; i++) {
            this.selectedDivision.push(this.division.selectedItems[i].id)
        }
        this.commaSeperatedDivisions = this.selectedDivision.join(", ")
        this.GetDivisionWiseData(this.division.selectedItems);
    }
    public onDivisionDeSelectAll(items: any) {
        this.selectedDivision = [];
        this.commaSeperatedDivisions = '';
        this.GetDivisionWiseData(this.division.selectedItems);
    }

    public onZoneSelect(item: any) {
        this.selectedZone = [];
        for (var i = 0; i < this.zone.selectedItems.length; i++) {
            this.selectedZone.push(this.zone.selectedItems[i].id)
        }
        this.commaSeperatedZones = this.selectedZone.join(", ");

        this.GetZoneWiseData(this.zone.selectedItems);
    }
    public onZoneDeSelect(item: any) {
        this.selectedZone = [];
        for (var i = 0; i < this.zone.selectedItems.length; i++) {
            this.selectedZone.push(this.zone.selectedItems[i].id)
        }
        this.commaSeperatedZones = this.selectedZone.join(", ");
        this.GetZoneWiseData(this.zone.selectedItems);
    }

    public onZoneSelectAll(items: any) {
        this.selectedZone = [];
        for (var i = 0; i < this.zone.selectedItems.length; i++) {
            this.selectedZone.push(this.zone.selectedItems[i].id)
        }
        this.commaSeperatedZones = this.selectedZone.join(", ");
        this.GetZoneWiseData(this.zone.selectedItems);
    }
    public onZoneDeSelectAll(items: any) {
        this.selectedZone = [];
        this.commaSeperatedZones = '';
        this.GetZoneWiseData(this.zone.selectedItems);
    }


    public onRegionSelect(item: any) {
        if (this.roleId != '42' && this.roleId != '76' && this.roleId!='43'  && this.roleId!='77'  && this.roleId!='39') {
            this.GetRegionWiseData(this.regionSelect.selectedItems);
        }
        else {
            this.selectedRegion = [];
            for (var i = 0; i < this.regionSelect.selectedItems.length; i++) {
                this.selectedRegion.push(this.regionSelect.selectedItems[i].id)
            }
            this.commaSeperatedRegions = this.selectedRegion.join(", ");

        }
    }
    public onRegionDeSelect(item: any) {
        if (this.roleId != '42' && this.roleId != '76' && this.roleId!='43'  && this.roleId!='77'  && this.roleId!='39') {
            this.GetRegionWiseData(this.regionSelect.selectedItems);
        }
        else {
            this.selectedRegion = [];
            this.commaSeperatedRegions = '';

        }
    }

    public onRegionSelectAll(items: any) {
        if (this.roleId != '42' && this.roleId != '76' && this.roleId!='43'  && this.roleId!='77'  && this.roleId!='39') {
            this.GetRegionWiseData(this.regionSelect.selectedItems);
        }
        else {
            this.selectedRegion = [];
            for (var i = 0; i < this.regionSelect.selectedItems.length; i++) {
                this.selectedRegion.push(this.regionSelect.selectedItems[i].id)
            }
            this.commaSeperatedRegions = this.selectedRegion.join(", ");
        }

    }
    public onRegionDeSelectAll(items: any) {
        this.selectedRegion = [];
        this.commaSeperatedRegions = '';
        this.rmh.selectedItems = [];
        //this.GetRegionWiseData(this.regionSelect.selectedItems);
    }
    public onRMHSelect(item: any) {
        this.GetRMHWiseData(this.rmh.selectedItems);
    }
    public onRMHDeSelect(item: any) {
        this.GetRMHWiseData(this.rmh.selectedItems);
    }

    public onRMHSelectAll(items: any) {
        this.GetRMHWiseData(this.rmh.selectedItems);
    }
    public onRMHDeSelectAll(items: any) {
        this.regionSelect.selectedItems = [];
        //this.GetRMHWiseData(this.rmh.selectedItems);
    }

    public onProductSelect(item: any) {
        this.GetProductWiseData(this.productSelect.selectedItems);
    }
    public onProductSelectAll(item: any) {
        this.GetProductWiseData(this.productSelect.selectedItems);
    }
    public onProductDeSelectAll(items: any) {
        this.cropSelect.selectedItems = [];
    }
    public onProductDeSelect(items: any) {
        this.GetProductWiseData(this.productSelect.selectedItems);
    }

    public onCropDeSelect(item: any) {
        this.GetCropWiseData(this.cropSelect.selectedItems);
    }
    public onCropSelectAll(item: any) {
        this.GetCropWiseData(this.cropSelect.selectedItems);
    }
    public onCropDeSelectAll(items: any) {
        this.productSelect.selectedItems = [];
    }
    public onCropSelect(items: any) {
        this.GetCropWiseData(this.cropSelect.selectedItems);
    }
    GetSBUWiseData(filter: any) {
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = this.FlagDropDown;
        this.ddlRequest.SBU = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
        this.ddlServices.getSBUHierarchyDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    this.rmh.selectedItems = [];
                    this.regionSelect.selectedItems = [];
                    this.zone.selectedItems = [];
                    this.division.selectedItems = [];
                    this.ddlResponse.division = response.data.division;
                    this.ddlResponse.zone = response.data.zone;
                    this.ddlResponse.region = response.data.region;
                    this.ddlResponse.rmh = response.data.rmh;

                    this.division.selectedItems = response.data.division.map(item => { return { id: item.divisionCode, text: item.divisionName } });
                    this.zone.selectedItems = response.data.zone.map(item => { return { id: item.zoneCode, text: item.zoneName } });
                    this.regionSelect.selectedItems = response.data.region.map(item => { return { id: item.regionCode, text: item.regionName } });
                    this.rmh.selectedItems = response.data.rmh.map(item => { return { id: item.rmhCode, text: item.rmhName } });
                }
                else {
                    this.toastr.error(response.message);
                }

            }, error => {
            });
    }
    GetDivisionWiseData(filter: any) {
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = this.FlagDropDown;
        this.ddlRequest.Division = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
        this.ddlServices.getDivisionHierarchyDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    this.rmh.selectedItems = [];
                    this.regionSelect.selectedItems = [];
                    this.zone.selectedItems = [];
                    this.ddlResponse.rmh = response.data.rmh;
                    this.ddlResponse.region = response.data.region;
                    this.ddlResponse.zone = response.data.zone;

                    this.zone.selectedItems = response.data.zone.map(item => { return { id: item.zoneCode, text: item.zoneName } });
                    this.regionSelect.selectedItems = response.data.region.map(item => { return { id: item.regionCode, text: item.regionName } });
                    this.rmh.selectedItems = response.data.rmh.map(item => { return { id: item.rmhCode, text: item.rmhName } });
                }
                else {
                    this.toastr.error(response.message);
                }

            }, error => {
            });
    }
    GetZoneWiseData(filter: any) {
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = this.FlagDropDown;
        this.ddlRequest.Zone = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
        this.ddlServices.getZoneHierarchyDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    this.rmh.selectedItems = [];
                    this.regionSelect.selectedItems = [];
                    this.ddlResponse.region = response.data.region;
                    this.ddlResponse.rmh = response.data.rmh;

                    this.regionSelect.selectedItems = response.data.region.map(item => { return { id: item.regionCode, text: item.regionName } });
                    this.rmh.selectedItems = response.data.rmh.map(item => { return { id: item.rmhCode, text: item.rmhName } });
                }
                else {
                    this.toastr.error(response.message);
                }

            }, error => {
            });
    }
    GetRegionWiseData(filter: any) {
        this.loader = 'block';
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = this.FlagDropDown;
        this.ddlRequest.Region = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
        this.ddlServices.getRegionWiseRMHDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    if (response.data.rmh.length > 0)
                        this.rmh.selectedItems = response.data.rmh.map(item => { return { id: item.rmhCode, text: item.rmhName } });
                    else
                        this.rmh.selectedItems = [];
                    // this.rmh.selectedItems = [];
                    // this.ddlResponse.rmh = response.data.rmh;
                    this.loader = 'none';
                }
                else {
                    this.toastr.error(response.message);
                    this.loader = 'none';
                }

            }, error => {
                this.loader = 'none';
            });
    }
    GetRMHWiseData(filter: any) {
        this.loader = 'block';
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.Flag = this.FlagDropDown;
        this.ddlRequest.RMH = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
        this.ddlServices.getRMHWiseRegionDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    if (response.data.region.length > 0)
                        this.regionSelect.selectedItems = response.data.region.map(item => { return { id: item.regionCode, text: item.regionName } });
                    else
                        this.regionSelect.selectedItems = [];
                    // this.regionSelect.selectedItems = [];
                    // this.ddlResponse.region = response.data.region;
                    this.loader = 'none';
                }
                else {
                    this.toastr.error(response.message);
                    this.loader = 'none';
                }

            }, error => {
                this.loader = 'none';
            });
    }

    GetProductWiseData(filter: any) {
        this.loader = 'block';
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.product = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
        this.ddlServices.getProductWiseCropDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    if (response.data.crop.length > 0)
                        this.cropSelect.selectedItems = response.data.crop.map(item => { return { id: item.cropId, text: item.cropName } });
                    else
                        this.cropSelect.selectedItems = [];
                    this.loader = 'none';
                }
                else {
                    this.toastr.error(response.message);
                    this.loader = 'none';
                }

            }, error => {
                this.loader = 'none';
            });
    }
    GetCropWiseData(filter: any) {
        this.loader = 'block';
        this.ddlRequest.UserId = this.userId;
        this.ddlRequest.Role = this.roleId;
        this.ddlRequest.crop = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
        this.ddlServices.getCropWisePorductDropDown(this.ddlRequest)
            .subscribe((response) => {
                if (response.status) {
                    if (response.data.product.length > 0)
                        this.productSelect.selectedItems = response.data.product.map(item => { return { id: item.productId, text: item.productName } });
                    else
                        this.productSelect.selectedItems = [];
                    this.loader = 'none';
                }
                else {
                    this.toastr.error(response.message);
                    this.loader = 'none';
                }

            }, error => {
                this.loader = 'none';
            });
    }
    onYearSelect(item: any) {
        let selectedyear = this.year.selectedItems[0].id;
        if(selectedyear != (new Date()).getFullYear().toString())
        {     
          var someElement= document.getElementById("ancUploadExcel"); 
          someElement.className = "";
          someElement.className += "hideuploadExcel";
        }
        else
        {
          document.getElementById("ancUploadExcel").classList.remove("hideuploadExcel");
        }
    }
    onStatusSelect(status: {status: string}){
        this.dropdownStatus = status;
    }
    onSSelect(item: any) {
        let selectedyear = this.year.selectedItems[0].status;
        if(selectedyear != (new Date()).getFullYear().toString())
        {     
          var someElement= document.getElementById("ancUploadExcel"); 
          someElement.className = "";
          someElement.className += "hideuploadExcel";
        }
        else
        {
          document.getElementById("ancUploadExcel").classList.remove("hideuploadExcel");
        }
    }
    DownloadExcel() {
        this.loader = 'block';
        this.userId = localStorage.getItem('dsu_userId');
        let today = new Date();
        let month;
        let year=0;
        if((today.getMonth() + 1)<10)
        {
             month = '0' + (today.getMonth() + 1).toString().slice(-2);
        }
        else
        {
             month =  (today.getMonth() + 1).toString().slice(-2);
        }
        
        let formattedDate = today.getDate() + "_" + month + "_" + today.getFullYear();
        let region = ''
        let roleId=0;
        if(this.roleId=="56"){
            if (this.regionSelect.selectedItems.length > 0) {
                region = Array.prototype.map.call(this.regionSelect.selectedItems, function (item) { return item.id; }).join(",");
            }
            else {
                this.toastr.error('Please select region.');
                this.loader = 'none';
                return false;
            }
        }
        else{
            if (this.regionSelect.selectedItems.length > 0) {
                region = Array.prototype.map.call(this.regionSelect.selectedItems, function (item) { return item.id; }).join(",");
            }
        }
        if (region.split(',').length > 20){
            this.toastr.error("Please select maximum 20 regions to download the excel");
            this.loader = 'none';
            return false;
        }    
        year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
        this.addReqServices.DownloadExcel(this.userId,region,year)
            .subscribe(success => {
                if (success.ok = true) {
                    var blob = new Blob([success.blob()], { type: 'application/vnc.openxmlformats-officedocument.spreadsheetxml.sheet' })
                    saveAs(blob, this.userName +"_"+year+ "_AdditionalRequirement_" + formattedDate + ".xlsx");
                }
                this.loader = 'none';
            }, err => {
                this.toastr.error("No data found");
                //alert("Some problem occurred while downloading file.");
                this.loader = 'none';
            });
    }
    filesDroppedAdd(files: File[]) {

        this.files = [];
        this.files = files;
        let fileNameParts: string[] = files[0].name.split('.');
        let fileType = files[0].name.split('.')[fileNameParts.length - 1];
        let UserId = localStorage.getItem('dsu_userId');
        let region = '';
        let product = '';
        let AnnualCycle='H1';

        if (fileType != 'xls' && fileType != 'xlsx') {
            this.file.nativeElement.value = '';
            this.toastr.error("Please Select Valid File Type.");
            return false;
        }
        if (this.regionSelect.selectedItems.length > 0) {
            region = Array.prototype.map.call(this.regionSelect.selectedItems, function (item) { return item.id; }).join(",");
        }
        if (this.productSelect.selectedItems.length > 0) {
            product = Array.prototype.map.call(this.productSelect.selectedItems, function (item) { return item.id; }).join(",");
        }
        this.loader = 'block';
        this.document.file = <File>this.files[0];
        this.addReqServices.uploadDocument(this.document.file, UserId, region, product,AnnualCycle)
            .subscribe((resData: any) => {
                if (resData.status == true) {
                    if (resData.data[0].result === "Success") {
                        this.toastr.success(resData.data[0].errordescription); 

                    }
                    else {
                        this.toastr.error(resData.data[0].errordescription);
                    }
                } else {
                    this.toastr.error(resData.message);
                }
                this.GetAdditionalRequirement(0,true);
                this.file.nativeElement.value = '';
                this.loader = 'none';
            }, error => {
                this.file.nativeElement.value = '';
                this.loader = 'none';
                this.toastr.error('Some Problem Occured,Please try again later.');
            });
       
    }
    GetAdditionalRequirement(currentPage: any,IsUpload:any) {
        debugger;
        this.loader = 'block';
        this.isDisabledPrevious = true;
        this.isDisabledNext = false;
        let region = ''
        let product = ''
        let crop = ''
        let year=0;
        let status = '';
        this.userId = localStorage.getItem('dsu_userId');
        this.startRecord = 1;

        if (this.regionSelect.selectedItems.length > 0) {
            region = Array.prototype.map.call(this.regionSelect.selectedItems, function (item) { return item.id; }).join(",");
        }
        else {
            if(IsUpload){
                region = Array.prototype.map.call(this.regionSelect._data, function (item) { return item.id; }).join(",");
           }
            else{
            this.toastr.error('Please select region.');
            this.loader = 'none';
            return false;
            }
        }
        if (this.productSelect.selectedItems.length > 0) {
            product = Array.prototype.map.call(this.productSelect.selectedItems, function (item) { return item.id; }).join(",");
        }
        if (this.cropSelect.selectedItems.length > 0) {
            crop = Array.prototype.map.call(this.cropSelect.selectedItems, function (item) { return item.id; }).join(",");
        }
        year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
        
        if (this.dropdownStatus == undefined) {
            status = '';
        } else {
            status= this.dropdownStatus.status;
        }
        
        let page = currentPage;
        this.addReqServices.GetAdditionalRequirement(this.userId, region, "", product, crop,year, page,status)
            .subscribe((response) => {

                debugger;
                if (response.status) {
                    debugger;
                    console.log(response.data);
                    this.defaultView = false;
                    this.additionalReqObj = response.data;
                    this.IsSubmittButtonDisable = this.additionalReqObj.isDisableSubmissionButton;
                    this.totalRecord = this.additionalReqObj.pagination.totalRecord;
                    this.currentPage = this.additionalReqObj.pagination.currentPage;
                    this.lastPage = this.additionalReqObj.pagination.lastPage;
                    this.recordsOnCurrentPage = this.additionalReqObj.pagination.recordOnPage;
                    this.endRecord = this.recordsOnCurrentPage;
                    if (this.currentPage == 1) {
                        localStorage.setItem("numberOfRecordsOnFirstPage", this.recordsOnCurrentPage.toString());
                    }
                    if (this.currentPage > 1) {
                        this.isDisabledPrevious = false;
                        this.startRecord = (this.currentPage - 1) * parseInt(localStorage.getItem("numberOfRecordsOnFirstPage"), 10) + 1;
                        this.endRecord = this.startRecord + this.recordsOnCurrentPage - 1;
                    }
                    if (this.currentPage == this.lastPage || this.totalRecord == 0) {
                        this.isDisabledNext = !this.isDisabledNext;
                        this.recordsOnCurrentPage = this.totalRecord;
                    } if (this.additionalReqObj.additionalRequirement.length == 0) {
                        this.startRecord = 0;
                        this.endRecord = 0;
                        this.recordsOnCurrentPage = 0;
                    }
                }
                else {
                    this.toastr.error(response.message);
                }
                this.loader = 'none';
            }, error => {
                this.loader = 'none';
            });

        this.getApprovalHistory(1);

    }
    finalSubmission() {
        this.loader = 'block';
        let region = ''
        if (this.regionSelect.selectedItems.length > 0) {
            region = Array.prototype.map.call(this.regionSelect.selectedItems, function (item) { return item.id; }).join(",");
        }
        else {
            this.toastr.error('Please select region.');
            this.loader = 'none';
            return false;
        }
        this.displayReject = 'none';
        this.addReqServices.FinalSubmission(this.userId, region)
            .subscribe((response) => {
                if (response.status) {
                    this.toastr.success(response.message);
                    this.IsSubmittButtonDisable = true;
                    this.GetAdditionalRequirement(0,false);
                }
                else {
                    this.toastr.error(response.message);
                    this.IsSubmittButtonDisable = false;
                }
                this.displayReject = 'none';
                this.loader = 'none';
            }, error => {
                this.IsSubmittButtonDisable = false;
                this.loader = 'none';
            });
    }
    closePopup() {

        this.displayReject = 'none';
    }
    openCommentPopup() {

        this.displayReject = 'block';
    }
    reset() {
        this.defaultValue = 'none';
        // if (this.requirmentType != undefined) {
        //   this.requirmentType.selectedItems = [];
        // }
        if (this.rmh != undefined) {
            this.rmh.selectedItems = [];
        }
        if (this.productSelect != undefined) {
            this.productSelect.selectedItems = [];
        }
        if (this.cropSelect != undefined) {
            this.cropSelect.selectedItems = [];
        }
        if (this.sbu != undefined) {
            this.sbu.selectedItems = [];
        }
        if (this.division != undefined) {
            this.division.selectedItems = [];
        }
        if (this.zone != undefined) {
            this.zone.selectedItems = [];
        }
        if (this.regionSelect != undefined) {
            this.regionSelect.selectedItems = [];
        }
        if(this.yearSelect!=undefined){
            this.yearSelect.selectedItems=[];
        }
    }
// modify getapporvalHistory
    getApprovalHistory(currentPageForHistory: number) {
        this.loader = 'block';
        this.isDisabledPreviousForHistory = true;
        this.isDisabledNextForHistory = false;
        this.startRecordForHistory=1;
        let region="";
        let currentpageForHistory = currentPageForHistory;
        let year=0;
        if (this.commaSeperatedSbus == undefined) {
            this.commaSeperatedSbus = '';
        }
        if (this.commaSeperatedDivisions == undefined) {
            this.commaSeperatedDivisions = '';
        }
        if (this.commaSeperatedZones == undefined) {
            this.commaSeperatedZones = '';
        } if (this.commaSeperatedRegions == undefined) {
            this.commaSeperatedRegions = '';
        }
        if (this.commaSeperatedRMH == undefined) {
            this.commaSeperatedRMH = '';
        }
        
        this.userId = localStorage.getItem('dsu_userId');
        this.selectedReqType = 'ADDITIONAL'; 
        this.roleId = localStorage.getItem('dsu_roleId'); 
        if (this.regionSelect.selectedItems.length > 0) {
            region = Array.prototype.map.call(this.regionSelect.selectedItems, function (item) { return item.id; }).join(",");
        }
        year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
        this.addReqServices.getApprovalHistory(currentPageForHistory,this.userId, this.roleId, this.selectedReqType, this.commaSeperatedSbus, this.commaSeperatedDivisions, this.commaSeperatedZones, region, this.commaSeperatedRMH,year)
            .subscribe((approvalData) => {
                if(approvalData.data == null){
                    this.startRecordForHistory = 0;
                    this.recordsOnCurrentPageForHistory = 0;
                    this.endRecordForHistory = 0;
                    this.totalRecordForHistory = 0;
                    this.approvalDetails = [];
                    this.isDisabledNextForHistory = true;
                }
                else{
                    this.approvalDetails = approvalData.data.approvalHistoryModels;
                    this.totalRecordForHistory=approvalData.data.pagination.totalRecord;
                    this.currentPageForHistory= approvalData.data.pagination.currentPage; 
                    this.lastPageForHistory = approvalData.data.pagination.lastPage;
                    this.recordsOnCurrentPageForHistory = approvalData.data.pagination.recordsOnPage;
                    this.endRecordForHistory = this.recordsOnCurrentPageForHistory;
                    if (this.currentPageForHistory == 1)
                    {
                        localStorage.setItem("numberOfRecordsOnFirstPageForHistory", this.recordsOnCurrentPageForHistory.toString());
                    }
                    if (this.currentPageForHistory > 1)
                    {
                        this.isDisabledPreviousForHistory = false;
                        // this.startRecordForHistory = (this.currentPageForHistory - 1) * (approvalData.data.length) + 1;
                        this.startRecordForHistory = (this.currentPageForHistory - 1) * parseInt(localStorage.getItem("numberOfRecordsOnFirstPageForHistory"), 10) + 1;
                        this.endRecordForHistory = this.startRecordForHistory + this.recordsOnCurrentPageForHistory - 1;
                    }
                    if (this.currentPageForHistory == this.lastPageForHistory || this.totalRecordForHistory == 0) {
                        this.isDisabledNextForHistory = !this.isDisabledNextForHistory;
                        this.recordsOnCurrentPageForHistory = this.totalRecordForHistory;
                    }
                }
                this.loader = 'none';
            }, error => {

                this.loader = 'none';
            });
    }
}